/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React from 'react';

import { IRecurrentContent } from 'models/recurrentDoubts';

import Video from 'shared/Video';
import Icon from 'shared/Icon';

import theme from 'styles/theme';

import {
  CardToggleComponent,
  Subitem,
  SubitensContent,
  MainItemContent,
} from './styles';

export interface IRecurrentDoubts {
  recurrentDoubtsObj: IRecurrentContent[];
  itensOpened: string[];
  setItensOpened: React.Dispatch<React.SetStateAction<string[]>>;
  subitensOpened: string[];
  setSubitensOpened: React.Dispatch<React.SetStateAction<string[]>>;
}

export function RecurrentDoubts({
  recurrentDoubtsObj,
  itensOpened,
  setItensOpened,
  subitensOpened,
  setSubitensOpened,
}: IRecurrentDoubts) {
  function retractSubitens(parentIndex: string) {
    const parentElement = document.getElementById(`item${parentIndex}`)
      ?.parentElement;

    const contentSubitens = parentElement?.lastChild?.childNodes;

    let subitensToMaintainOpened: string[] = subitensOpened;

    contentSubitens?.forEach((item) => {
      const subitemHeader = item.firstChild as HTMLElement;

      const subitemIndex = subitemHeader
        ? subitemHeader.getAttribute('id')!.replace(/^\D+/g, '')
        : '';

      if (subitensToMaintainOpened.includes(subitemIndex)) {
        subitensToMaintainOpened = subitensToMaintainOpened.filter(
          (subitem) => subitem !== subitemIndex,
        );
      }
    });

    setSubitensOpened(subitensToMaintainOpened);
  }

  function openItem(e: React.MouseEvent<HTMLDivElement, MouseEvent>) {
    const { id } = e.currentTarget;
    const itemIndex = id ? id.replace(/^\D+/g, '') : '';

    let itensToOpen = [...itensOpened, itemIndex];

    if (itensOpened.includes(itemIndex)) {
      itensToOpen = itensOpened.filter((item) => item !== itemIndex);
      retractSubitens(itemIndex);
    }

    setItensOpened(itensToOpen);
  }

  function openSubitem(e: React.MouseEvent<HTMLDivElement, MouseEvent>) {
    const { id } = e.currentTarget;
    const itemIndex = id ? id.replace(/^\D+/g, '') : '';

    let subitemToOpen = [...subitensOpened, itemIndex];

    if (subitensOpened.includes(itemIndex)) {
      subitemToOpen = subitensOpened.filter((item) => item !== itemIndex);
    }

    setSubitensOpened(subitemToOpen);
  }

  return (
    <>
      {recurrentDoubtsObj.map((mainItem) => (
        <CardToggleComponent key={mainItem.id}>
          <div
            id={`item${mainItem.id}`}
            className="mainitem"
            onClick={openItem}
          >
            <p>{mainItem.title}</p>
            <div className="countSubItens">
              {itensOpened.includes(mainItem.id) ? (
                <Icon
                  color={theme.colors.quaternary}
                  name="minusSquare"
                  width="20"
                  height="19"
                />
              ) : (
                <Icon
                  color={theme.colors.primary}
                  name="plusSquare"
                  width="20"
                  height="19"
                />
              )}
            </div>
          </div>
          <SubitensContent isOpen={itensOpened.includes(mainItem.id)}>
            <Subitem
              isOpen={subitensOpened.includes(mainItem.id)}
              className="subitem"
              key={mainItem.id}
            >
              <div
                id={`subitem${mainItem.id}`}
                className="header"
                onClick={openSubitem}
              >
                <MainItemContent
                  dangerouslySetInnerHTML={{ __html: mainItem.content }}
                />

                <Video url={mainItem.contentVideo} />
              </div>
            </Subitem>
          </SubitensContent>
        </CardToggleComponent>
      ))}
    </>
  );
}
